export interface CompetitorChartData {
  referenceProductId: string;
  series: CompetitorSeries[];
  totals: CompetitorTotalPoint[];
}

export interface CompetitorSeries {
  productId: string;
  itemNumber: string;
  description: string;
  marketAuthorizationHolder: string;
  hasPackSize: boolean;
  packSizeA: number;
  packSizeB: number;
  points: CompetitorPoint[];
}

export interface CompetitorTotalPoint {
  date: string;
  periodEndDate: string;
  hasData: boolean;
  turnover: number;
  currency: string;
  packs: number;
  units: number;
}

// Shares are percentages (0-100) of the total for the same date.
export interface CompetitorPoint extends CompetitorTotalPoint {
  turnoverShare: number;
  packsShare: number;
  unitsShare: number;
}

export enum CompetitorSubMarket {
  Primary = 1,
  Hospital = 2,
}
